import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';

import { ACTIONS_TYPES } from 'redux/helper';
import { ROUTE } from 'constant';
import { useSelector } from 'react-redux';
import { MonitoringAction } from 'models';
import CreateForm from './create';

export const MonitoringActionsList = ({ history }) => {
  const { listViewType = '', [ACTIONS_TYPES.MONITORING.ACTION.GET_ALL]: monitoringActions = [] } = useSelector((e) => e);
  useEffect(() => {
    actions.common.setLayoutTitle({ layout: { title: 'Monitoring Actions', menu: ROUTE.DASHBOARD.MONITORING.key } });
    actions.monitoring.action.getAll();
  }, []);

  return (
    <div style={{ margin: '15px 10px' }} className="screen-common">
      <Shared.widgets.Cards
        title="Actions"
        type="common"
        isFilter={false}
        addAction={ACTIONS_TYPES.MONITORING.ACTION.CREATE}
        addRender={<CreateForm />}
        isEmpty={!monitoringActions.length}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              monitoringActions.map((action) => {
                const { id, properties = {} } = new MonitoringAction(action);
                const { name = '', typeProperties = {} } = properties;
                const { emailTo = '' } = typeProperties;

                return ([
                  {
                    value: name,
                    link: id,
                  },
                  emailTo,
                ]);
              })
            }
            onCellClick={(id) => history.push(ROUTE.DASHBOARD.MONITORING_ACTION.path.replace(':id', id))}
            columns={[
              { name: 'Name' },
              { name: 'Email' },
            ]}
          />
        ) : (
          monitoringActions.map((action) => {
            const { id, properties = {} } = new MonitoringAction(action);
            const { name = '', typeProperties = {} } = properties;
            const { emailTo = '' } = typeProperties;

            return (
              <Shared.widgets.CardBasic
                icon="paper-plane"
                title={name}
                details={emailTo}
                onClick={() => history.push(ROUTE.DASHBOARD.MONITORING_ACTION.path.replace(':id', id))}
                key={id}
              />
            );
          }))}
      </Shared.widgets.Cards>
    </div>
  );
};
